// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__34JPx","noInteraction":"EventWrapper_noInteraction__Fzoj9"};